import React, { useState } from "react";
import { Patient } from "../../public/UsagePolicy";
import { TermsServiceSection } from "../../public/TermsService";
import styles from "./ModalTermsService.module.css";

function ModalTermsService({ show, onConfirm, onCancel }) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [agreed1, setAgreed1] = useState(false);
  const [agreed2, setAgreed2] = useState(false);

  if (!show) return null;

  const reset = () => {
    setExpanded1(false);
    setExpanded2(false);
    setAgreed1(false);
    setAgreed2(false);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.title}>ข้อตกลงและนโยบาย</span>
        </div>

        <div className={styles.body}>
          <div className={styles.accordionCard}>
            <div
              className={styles.accordionRow}
              onClick={() => setExpanded1(!expanded1)}
            >
              <div className={styles.rowLeft}>
                <span className={`${styles.chevron} ${expanded1 ? styles.chevronOpen : ""}`}>›</span>
                <span className={styles.sectionTitle}>นโยบายความเป็นส่วนตัว</span>
              </div>
              <label
                className={styles.toggleLabel}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  className={styles.toggleInput}
                  checked={agreed1}
                  onChange={(e) => setAgreed1(e.target.checked)}
                />
                <span className={styles.toggleSlider} />
              </label>
            </div>
            {expanded1 && (
              <div className={styles.accordionContent}>
                <Patient data="policy" hideTabs />
              </div>
            )}
          </div>

          <div className={styles.accordionCard}>
            <div
              className={styles.accordionRow}
              onClick={() => setExpanded2(!expanded2)}
            >
              <div className={styles.rowLeft}>
                <span className={`${styles.chevron} ${expanded2 ? styles.chevronOpen : ""}`}>›</span>
                <span className={styles.sectionTitle}>ข้อกำหนดและเงื่อนไขการใช้บริการ</span>
              </div>
              <label
                className={styles.toggleLabel}
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  className={styles.toggleInput}
                  checked={agreed2}
                  onChange={(e) => setAgreed2(e.target.checked)}
                />
                <span className={styles.toggleSlider} />
              </label>
            </div>
            {expanded2 && (
              <div className={styles.accordionContent}>
                <TermsServiceSection />
              </div>
            )}
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.btnCancel} onClick={() => { reset(); onCancel(); }}>
            ยกเลิก
          </button>
          <button
            className={`${styles.btnConfirm} ${!(agreed1 && agreed2) ? styles.btnDisabled : ""}`}
            onClick={() => { if (agreed1 && agreed2) { reset(); onConfirm(); } }}
            disabled={!(agreed1 && agreed2)}
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalTermsService;
